import { Body } from '@assembly-js/design-system';
import type { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

export const TextCellRenderer: React.FC<ICellRendererParams> = React.memo(
  (cellData) => (
    <Body tag="div" size="sm" className="text-black-heading !leading-5">
      {cellData.valueFormatted || cellData.value}
    </Body>
  ),
);
